import { Controller } from '@hotwired/stimulus'
import { api } from '../../api'

export default class SystemNotificationController extends Controller {
  declare readonly idValue: string

  static values = { id: String }

  // Public methods
  async close() {
    await api.systemNotifications.close({ id: this.idValue })
    this.dispatch('closed')
  }
}
